"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRectangleWidth = void 0;
const getRectangleWidth = ({
  isNext = false,
  isPrevious = false
} = {}) => {
  if (isNext || isPrevious) {
    return '25px';
  }
  return '35px';
};
exports.getRectangleWidth = getRectangleWidth;
//# sourceMappingURL=getRectangleWidth.js.map